import styled from 'styled-components';

export const ArticleColumnRoot = styled.div`
    border: 1px dashed ${(props) => props.theme.LighterBorderColor};
    background: ${(props) => props.theme.LayoutBodyBackground};
    min-width: 0;
    padding: 0.75rem;
`;

export const ArticleBlockAddToolbar = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
    margin-bottom: 0.75rem;
`;

export const ArticleBlocksList = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 0.75rem;
    min-height: 3.5rem;
    background: ${(props) => (props.$isDraggingOver ? props.theme.LightBlueBackground : 'transparent')};
    transition: background 0.2s ease;
`;
